import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { DfpComponent } from "../../ads/dfp-component";
import StoryCard from "./StoryCard";

import "./six-col-six.m.css";

export const getStoryAttribute = (story) => {
  const label = get(story, ["metadata", "story-attributes", "label", "0"], "");
  return label;
};
export default function SixColumnSixStories({ collection, stories, extraProp = "" }) {
  const associatedMetadata = get(collection, ["associated-metadata"], {});
  const sponsorAdDetails = associatedMetadata.sponsor_ad_details || null;
  const enableRowAd = associatedMetadata.enable_row_ad || null;
  const rowAdDetails = associatedMetadata.row_ad_details || null;
  const showColumnSeparator = associatedMetadata.show_column_separator || null;
  const showRowSeparator = associatedMetadata.show_row_separator || null;
  const rowAdUnitBottom = associatedMetadata.show_row_ad_unit_bottom || null;
  const showRowTitle = associatedMetadata.show_row_title || null;
  const showTimeStamp = associatedMetadata.show_timestamp || null;
  const showReadTime = associatedMetadata.show_read_time || null;
  const enableSponsorAd = associatedMetadata.enable_sponsor_ad || null;

  const nativeAdUnit = rowAdDetails?.split("/").slice(-1)[0];
  const nativeAddivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", nativeAdUnit], "")
  );
  const rowAdBottom = rowAdUnitBottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );
  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const sectionSlug = extraProp;
  return (
    <div className="row-component" styleName="top-component-wrapper">
      <div styleName="six-col-six-stories">
        {showRowTitle && (
          <CollectionTitle
            collection={collection}
            enableSponsorAd={enableSponsorAd}
            sponsorAdDetails={sponsorAdDetails}
            sectionSlug={sectionSlug}
            sponsorAdConfig={sponsorAdConfig}
          />
        )}
        <div styleName={`${showColumnSeparator ? "stories-list-with-seperator" : "stories-list"}`}>
          {stories.map((story, index) => {
            return (
              <>
                {index === 2 && enableRowAd ? (
                  <DfpComponent adStyleName="six-col-six-ad-slot-size-160x252" id={nativeAddivId} isSponsored={true} />
                ) : (
                  <StoryCard
                    key={index}
                    story={story}
                    showTimeStamp={showTimeStamp}
                    showReadTime={showReadTime}
                    sectionSlug={sectionSlug}
                  />
                )}
                {showColumnSeparator && index !== stories.length - 1 && <div styleName="divider"></div>}
              </>
            );
          })}
        </div>
      </div>
      {showRowSeparator && <RowSeparator />}
      {rowAdUnitBottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
}

SixColumnSixStories.propTypes = {
  collection: PropTypes.shape({
    slug: PropTypes.string,
  }),
  stories: PropTypes.array.isRequired,
  extraProp: PropTypes.string,
};

SixColumnSixStories.storyLimit = 6;
